import { render } from "./Submit.vue?vue&type=template&id=e340e534&scoped=true&lang=pug"
import script from "./Submit.vue?vue&type=script&setup=true&lang=js"
export * from "./Submit.vue?vue&type=script&setup=true&lang=js"

import "./Submit.vue?vue&type=style&index=0&id=e340e534&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e340e534"]])

export default __exports__